import React from 'react';
import {Row, Col} from 'react-flexbox-grid/lib';
import CircularProgress from 'material-ui/CircularProgress';
import FlatButton  from 'material-ui/FlatButton';
import { localize } from 'react-localize-redux';
import styles from './styles/SpinnerLoaderWithTextStyles';
import Paper from 'material-ui/Paper';

/**
 * usato per il caricamento di dati in tabelle e controlli
 * @param {*} param0
 */
const SpinnerLoaderWithText = ({ translate, currentLanguage }) => (
<Paper style={styles.paper} >
  <Row style={styles.container} >
      <Col xs={12} >
          <FlatButton  label={translate('GLOBAL.loading')}
            disabled={true}
            icon={<CircularProgress size={25} />} >
          </FlatButton>
      </Col>
    </Row>
</Paper>

);

export default localize(SpinnerLoaderWithText, 'locale');


// WEBPACK FOOTER //
// ./src/components/loaders/SpinnerLoaderWithText.js